import React from "react";
import { useLocation } from "react-router-dom";
import "./style/header.scss";
import { useProgressStep } from "../../../hooks/useProgressStep";
import { useAppConfig } from "../../../hooks/useAppConfig";
import { useStrings } from "../../../hooks/useStrings";
import LanguageDropdown from "../../common/LanguageDropdown/LanguageDropdown";
import visitlyLogo from "../../../assets/images/footer-logo.png";
import { ROUTES } from "../../../utils/constants";

const LANGUAGE_DROPDOWN_ROUTES = [
  `/${ROUTES.FULL_NAME}`,
  `/${ROUTES.PRIVACY_POLICY}`,
  `/${ROUTES.SIGN_OUT}`,
  `/${ROUTES.PRE_FILL_DETAILS}`,
];

const Header: React.FC = () => {
  const { showProgress, stepNumber, totalSteps, stepLabel } = useProgressStep();
  const { config } = useAppConfig();
  const S = useStrings();
  const { pathname } = useLocation();
  const logoSrc = config?.logoURI || visitlyLogo;
  const showLanguageDropdown = LANGUAGE_DROPDOWN_ROUTES.includes(pathname);

  return (
    <>
      {!showProgress && (
        <div className="empty-box">
          <div className="empty-box-spacer" />
          <img
            src={logoSrc}
            alt="logo"
            className="empty-box-logo"
            onError={(e) => {
              const img = e.currentTarget as HTMLImageElement;
              img.onerror = null;
              img.src = "/assets/images/footer-logo.png";
            }}
          />
          <div className="empty-box-right">
            {showLanguageDropdown && <LanguageDropdown />}
          </div>
        </div>
      )}
      {showProgress && (
        <div className="progress-box">
          <div className="progress-box-header">
            <div>
              {S.HEADER.STEP}{stepNumber}{S.HEADER.OF}{totalSteps}
            </div>
            <img
              src={logoSrc}
              alt="logo"
              className="empty-box-logo"
              onError={(e) => {
                const img = e.currentTarget as HTMLImageElement;
                img.onerror = null;
                img.src = "/assets/images/footer-logo.png";
              }}
            />
            <div>{stepLabel}</div>
          </div>
          {showLanguageDropdown && <LanguageDropdown />}
          {/* Progress Bar */}
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: `${(stepNumber / totalSteps) * 100}%` }}
            ></div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
